// src/styles/theme.js
import { createTheme } from '@mui/material/styles';
import { grey } from '@mui/material/colors'; // Import grey for palette.grey

const muiTheme = createTheme({
  palette: {
    primary: {
      main: '#52357B',    // A vibrant purple
      light: '#8F87F1',   // You can use secondary as light, or define a new light shade
      dark: '#B17DDD',    // A slightly darker shade of primary for hover states
      contrastText: '#ffffff', // Text color that contrasts well with primary
    },
    secondary: {
      main: '#8F87F1',    // A lighter, softer purple/blue
      light: '#A0A0FF',   // A slightly lighter shade (example)
      dark: '#7A72E0',    // A slightly darker shade of secondary for hover states
      contrastText: '#ffffff', // Text color that contrasts well with secondary
    },
    background: {
      default: '#f0f2f5', // Main page background color
      paper: '#ffffff',   // Background for Paper components (cards, etc.)
    },
    text: {
      primary: '#333',    // Dark text for general readability
      secondary: '#2C3E50', // Dark blue for secondary text
      // You can also define custom properties here if needed, e.g.,
      // light: '#f8f9fa',
    },
    error: {
      main: '#dc3545',    // Standard error red
    },
    success: {
      main: '#28a745',    // Standard success green
    },
    // IMPORTANT: Define grey colors explicitly in your palette if you use them directly
    grey: {
        '50': grey[50],
        '100': grey[100],
        '200': grey[200],
        '300': grey[300], // The value your error was about
        '400': grey[400],
        '500': grey[500],
        '600': grey[600],
        '700': grey[700],
        '800': grey[800],
        '900': grey[900],
        A100: grey.A100,
        A200: grey.A200,
        A400: grey.A400,
        A700: grey.A700,
    },
  },
  typography: {
    fontFamily: 'Roboto, sans-serif',
    // You can define other typography variants here (h1, h2, body1, etc.)
  },
  spacing: 8, // Material-UI's default spacing unit is 8px.
  shape: {
    borderRadius: 8, // Material-UI uses numbers for borderRadius
  },
  // You can add your custom properties here for styled-components to pick up
  // These will be accessible via `theme.custom.fonts.main` etc.
  custom: {
    fonts: {
      main: 'Roboto, sans-serif',
    },
    spacing: {
      small: '8px',
      medium: '16px',
      large: '24px',
      xLarge: '32px',
    },
    borderRadius: '8px', // Can be used directly or via theme.shape.borderRadius
    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
  },
  // Override default Material-UI component styles here
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          textTransform: 'none', // Buttons default to uppercase
        },
      },
    },
    MuiPaper: {
        styleOverrides: {
            root: {
                // Use the custom boxShadow defined above if desired
                // or define a Material-UI shadow here: theme.shadows[3]
                // If you want your specific custom shadow, you might need to use `theme.custom.boxShadow`
                // For now, let's use a Material-UI shadow for consistency if you're leaning M-UI
                // or ensure `styled-components` picks up `custom.boxShadow`
                boxShadow: '0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)', // Default M-UI shadow example
                // Or, if you want your custom one from `custom.boxShadow` defined above:
                // boxShadow: theme.custom.boxShadow, // THIS WON'T WORK directly here, as `theme` isn't fully built yet.
                                                   // You'd need to define your custom shadows in `theme.shadows` array
                                                   // or access `muiTheme.custom.boxShadow` if you define it outside `createTheme`
            },
        },
    },
    MuiTextField: {
        styleOverrides: {
            root: {
                '& .MuiOutlinedInput-root': {
                    borderRadius: '8px',
                },
            },
        },
    },
  },
});

export default muiTheme; // Export the Material-UI theme